import { render } from "./FeaturesBar.vue?vue&type=template&id=2ff70fac&scoped=true"
import script from "./FeaturesBar.vue?vue&type=script&lang=js"
export * from "./FeaturesBar.vue?vue&type=script&lang=js"

import "./FeaturesBar.vue?vue&type=style&index=0&id=2ff70fac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ff70fac"]])

export default __exports__